import jwtDecode from 'jwt-decode';

const LOCAL_STORAGE = 'TSS_STORAGE';
const PERSISTANT_LOCAL_STORAGE = 'TSS_PERSISTANT_STORAGE';
const AUTH_TOKEN_KEY = '_s18cp0_';
const PREF_KEY = '_pso537br';
const INSERT_MISSING_DATA = 'INSERT_MISSING_DATA';

export const getLocalStorage = () => !!window.localStorage[LOCAL_STORAGE] ? JSON.parse(window.localStorage[LOCAL_STORAGE]) : {};
export const setLocalStorage = (key, value) => window.localStorage[LOCAL_STORAGE] = JSON.stringify(Object.assign(getLocalStorage(), { [key]: value }));
export const getFromLocalStorage = key => !!getLocalStorage() ? getLocalStorage()[key] : null;

const getPersistantLocalStorage = () => !!window.localStorage[PERSISTANT_LOCAL_STORAGE] ? JSON.parse(window.localStorage[PERSISTANT_LOCAL_STORAGE]) : {};
const setPersistantLocalStorage = (key, value) => window.localStorage[PERSISTANT_LOCAL_STORAGE] = JSON.stringify(Object.assign(getPersistantLocalStorage(), { [key]: value }));
const getFromPersistantLocalStorage = key => !!getPersistantLocalStorage() ? getPersistantLocalStorage()[key] : null;

export const clearLocalStorage = () => delete window.localStorage[LOCAL_STORAGE];

export const removeFromLocalStorage = key => {
  let storage = getLocalStorage();
  delete storage[key];
  window.localStorage[LOCAL_STORAGE] = JSON.stringify(Object.assign(storage));
};

let permissions = [];

export const token = {
  getEncoded: () => !!getFromLocalStorage(AUTH_TOKEN_KEY) ? getFromLocalStorage(AUTH_TOKEN_KEY).split('').reverse().join('') : null,
  getDecoded: () => {
    try {
      return !!getFromLocalStorage(AUTH_TOKEN_KEY) ? jwtDecode(getFromLocalStorage(AUTH_TOKEN_KEY).split('').reverse().join('')) : null
    } catch (err) {
      return err;
    }
  },
  setToken: token => setLocalStorage(AUTH_TOKEN_KEY, token.split('').reverse().join('')),
  removeToken: () => removeFromLocalStorage(AUTH_TOKEN_KEY),
  setPermissions: arr => permissions = arr,
  getPermissions: () => permissions.length === 0 ? token.getDecoded().permissions : permissions,
};

export const preference = {
  get: () => JSON.parse(getFromLocalStorage(PREF_KEY) || '{}'),
  set: obj => {
    // console.trace(JSON.parse(getFromLocalStorage(PREF_KEY) || '{}'), obj);
    // console.log(Object.assign(JSON.parse(getFromLocalStorage(PREF_KEY) || '{}'), obj));
    setLocalStorage(PREF_KEY, JSON.stringify(Object.assign(JSON.parse(getFromLocalStorage(PREF_KEY) || '{}'), obj)))
  }
};

export const insertMissingTimeStampData = {
  get: () => JSON.parse(getFromLocalStorage(INSERT_MISSING_DATA) || false),
  set: obj => {
    setLocalStorage(INSERT_MISSING_DATA, obj)
  }
};


const IMAGE_POS_KEY = `cvi&ucw3cn8*_${token.getDecoded() && token.getDecoded().id}`;
const TAGS_KEY = `woeijhfeujgvru_${token.getDecoded() && token.getDecoded().id}`;
const PAGINATION_KEY = `hvweh3&es$ue3#8c$9x(r_${token.getDecoded() && token.getDecoded().id}`;

export const imagePopupPosition = {
  get: id => JSON.parse(getFromPersistantLocalStorage(IMAGE_POS_KEY) || '{}')[id],
  set: (id, pos) => setPersistantLocalStorage(IMAGE_POS_KEY, JSON.stringify(Object.assign(JSON.parse(getFromPersistantLocalStorage(IMAGE_POS_KEY) || '{}'), { [id]: pos }))),
  remove: id => {
    let pos = JSON.parse(getFromPersistantLocalStorage(IMAGE_POS_KEY) || '{}');
    if (!!pos && !!pos[id]) {
      delete pos[id];
    }
    setPersistantLocalStorage(IMAGE_POS_KEY, JSON.stringify(pos));
  }
}

export const tags = {
  get: () => JSON.parse(getFromPersistantLocalStorage(TAGS_KEY) || '[]'),
  set: json => setPersistantLocalStorage(TAGS_KEY, JSON.stringify(json)),
}

export const pagination = {
  get: () => getFromPersistantLocalStorage(PAGINATION_KEY) || 25,
  set: pagination => setPersistantLocalStorage(PAGINATION_KEY, pagination),
}

// const token = {
//   getEncoded: () => window.localStorage.token,
//   getDecoded: () => jwtDecode(window.localStorage.token),
//   setToken: token => window.localStorage.token = token,
//   removeToken: () => delete window.localStorage.token,
//   getPermissions: () => permissions.length === 0 ? jwtDecode(window.localStorage.token).permissions : permissions,
//   setPermissions: arr => permissions = arr,
// };

// export default token;



// WEBPACK FOOTER //
// ./src/libs/localStorage.js